import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APP_INSIGHTS_KEY } from '@/app/core/common/config';

export const AppInsights = APP_INSIGHTS_KEY
    ? new ApplicationInsights({
          config: {
              instrumentationKey: APP_INSIGHTS_KEY,
              enableAutoRouteTracking: true,
              enableUnhandledPromiseRejectionTracking: true,
          },
      })
    : null;
